import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/main.css'
import { createMetaManager, plugin as metaPlugin } from 'vue-meta'


const metaManager = createMetaManager()
createApp(App).use(store).use(router).use(metaManager).use(metaPlugin).mount('#app')
